<div class="row mx-0 sg-RTA-container">
    <form [formGroup]="RTAForm" class="w-100 row mx-0">
        <div class="sg-documents-container ml-3 sg-header-section w-100">
            <div class="row mx-0 margin-top-bottom mt-3">
                <div class="col-6 cws-form-header">
                    <h4 class="sg-page-title"> RTA Form</h4>
                </div>
            </div>
            <div class="cws-back-button ml-3 cursor">
                <div class="row mx-0"><a class="underline" (click)="onClickBackOrClose()">Back</a></div>
            </div> 
        </div>
        <div class="sg-body-section w-100">
            <mat-drawer-container class="sg-main cws-form-container sg-RTA">
            <div class="cws-width pr-4 pl-2">
                <div class="row mx-0 mb-3 p-2 w-100 sg-edit-info border rounded" *ngIf="isRTAReadOnly">
                    <span class="material-icons-outlined pr-2 sg-supplier-management-info">info</span> 
                    <span class="pt-1"> This form is not editable at the moment. Contact Solar if modification are required</span>
                </div> 
                <!-- <div class="row mx-0 flex-column"> -->
                    <div class="mat-dialog-title mb-0 border-bottom  cws-header">General RTA Information</div>
                    <div class="row pl-3 pr-3">
                        <div class="col-3 p-0">
            
                            <div class="sg-form-field-label pt-3 pb-1">
                                RTA Number
                            </div>
                            <div>
                                <!-- PBI 314702: prefer Windchill Number over SG-local rtaNumber. -->
                                {{this.getEditRTAInfo ? (this.generalRTAInformation.number || this.generalRTAInformation.rtaNumber || '-') : '-'}}
                            </div>
                            <div class="sg-form-field-label pt-3 pb-1">
                                RTA Status
                            </div>
                            <div>
                                {{this.getEditRTAInfo ? this.generalRTAInformation.rtaStatus : '-'}}
                            </div>
                        </div>
                        <div class="col-3">
                            <div class="sg-form-field-label pt-3 pb-1">
                                RTA Revision Number
                            </div>
                            <div>
                                {{this.getEditRTAInfo ? this.generalRTAInformation.rtaRevison : '-'}}
                            </div>
                            <div class="sg-form-field-label pt-3 pb-1">
                                Supplier Reference #
                            </div>
                            <div>
                                <mat-form-field class="w-100 sg-validation" appearance="outline">
                                    <input matInput formControlName="supplierReference"/>
                                    <mat-error *ngIf="RTAForm.controls.supplierReference.errors?.pattern ||
                                    RTAForm.controls.supplierReference.errors?.hasBackSlash">
                                        The characters \ / * ? " < > | are not allowed.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <!-- Created By intentionally not shown: Windchill records the SG service
                             account (SUP9999) as Author, which would mislead suppliers. -->
                        <div class="col-3">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Created On
                            </div>
                            <div>
                                {{this.getEditRTAInfo ? this.generalRTAInformation.submittedDate : '-'}}
                            </div>
                        </div>
                    </div>
                <!-- </div> -->
                <div class="row mx-0 flex-column">
                <ng-container formGroupName="rtaRequestDetails">
                    <div class="mat-dialog-title mb-0 border-bottom  cws-header">Section 1A - RTA Request Details </div>
                    <!-- Windchill contract header fields (PBI 368007-Part2). Dropdowns bound to /RTALookup/GetByDomain. -->
                    <div class="row px-3 pt-3">
                        <div class="col-4 pl-0">
                            <label class="sg-form-field-label d-block font-weight-normal w-100">
                                Part Number <span class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput formControlName="partNumber" />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.partNumber').hasError('required')">
                                    This is required Field
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.partNumber').hasError('pattern') || RTAForm.get('rtaRequestDetails.partNumber').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <label class="sg-form-field-label d-block font-weight-normal w-100">
                                Department
                            </label>
                            <!-- Fixed by Windchill (always ENG); not a supplier choice. -->
                            <mat-form-field class="w-100" appearance="outline">
                                <input matInput readonly [value]="department.value">
                            </mat-form-field>
                        </div>
                        <div class="col-4">
                            <label class="sg-form-field-label d-block font-weight-normal w-100">
                                Value Stream <span class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <mat-select formControlName="valueStream" class="sg-select-sup">
                                    <mat-option *ngFor="let opt of valueStreamOptions" [value]="opt.code">
                                        {{opt.displayValue}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.valueStream').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row px-3 pt-3">
                        <div class="col-3 pl-0">
                            <label class="sg-form-field-label d-block font-weight-normal w-100">
                                Routing Type
                            </label>
                            <!-- Always External from SG; shows Windchill's value on reopen. Never submitter-controlled. -->
                            <mat-form-field class="w-100" appearance="outline">
                                <input matInput readonly [value]="routingType.value">
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <label class="sg-form-field-label d-block font-weight-normal w-100">
                                Product Model
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <mat-select formControlName="productModel" class="sg-select-sup">
                                    <mat-option value="">--</mat-option>
                                    <mat-option *ngFor="let opt of productModelOptions" [value]="opt.code">
                                        {{opt.displayValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row px-3 pt-3">
                        <div class="col-6 pl-0">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Supplier / CAM Name <span
                                    *ngIf="!isSupplierAutoPopulated"
                                    class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <!-- PBI 368007-Part2 / Windchill Q10: auto-populated from logged-in
                                 supplier; display as read-only text field. Form control still
                                 holds the supplier object for downstream save / upload code. -->
                            <!-- TEMP: admins submitting on behalf of a supplier pick it here instead. -->
                            <mat-form-field *ngIf="isAdminOnBehalf" class="w-100 sg-validation" appearance="outline">
                                <mat-select formControlName="supplierOrCamName" class="sg-select-sup"
                                    [compareWith]="compareSuppliers" placeholder="Select supplier">
                                    <mat-option *ngFor="let item of supplierResults" [value]="item">
                                        {{item.supplierName}} <span class="sg-supplier-code">{{item.organizationCode}}</span>
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.supplierOrCamName').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field *ngIf="!isAdminOnBehalf" class="w-100" appearance="outline">
                                <input matInput readonly [value]="supplierDisplay">
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Phone <span
                                    class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput formControlName="phone" phoneMask />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.phone').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.phone').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.phone').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Email <span
                                    class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput  formControlName="email" />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.email').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.email').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.email').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row px-3 pt-3">
                        <div class="col-3 pl-0">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Solar Purchase Order #
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput formControlName="solarPurchaseOrder" />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.solarPurchaseOrder').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.solarPurchaseOrder').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.solarPurchaseOrder').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Solar Production Order #
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput formControlName="solarProductionOrder" />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.solarProductionOrder').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.solarProductionOrder').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.solarProductionOrder').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                Operation #
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput  formControlName="operation" />
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.operation').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.operation').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.operation').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row px-3 pt-3">
                        <div class="col-6 pl-0">
                            <label class="sg-form-field-label pl-0">
                                Is Nonconforming Condition a Critical to Quality (CTQ) characteristic? <span
                                class="sg-form-field-required-marker ml-1">*</span>
                                <span class="material-icons-outlined sg-supplier-management-info"
                                     matTooltip="Select 'Yes', if the print is identified with a CTQ mark">help
                                </span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <mat-select formControlName="isNonconformingConditionCtq"  class="sg-select-sup">
                                    <mat-option value="Yes">Yes</mat-option>
                                    <mat-option value="No">No</mat-option>                           
                                </mat-select>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.isNonconformingConditionCtq').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <label class="sg-form-field-label pl-0">
                                Cause of Nonconformance <span
                                class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <textarea matInput formControlName="causeOfNonconformance" rows="3" maxlength="500"></textarea>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.causeOfNonconformance').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.causeOfNonconformance').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.causeOfNonconformance').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
        
                        </div>
                    </div>
                    <div class="row px-3 pt-3">
                        <div class="col-6 pl-0">
                            <label class="sg-form-field-label pl-0">
                                Proposed Correction <span
                                class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <textarea formControlName="proposedCorrection" matInput rows="3" maxlength="500"></textarea>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.proposedCorrection').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.proposedCorrection').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.proposedCorrection').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <label class="sg-form-field-label pl-0">
                                Comments / Previous Submittals / First Parts / Suggested Repair Plan <span
                                class="sg-form-field-required-marker ml-1">*</span>
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <textarea formControlName="commentsOrSrp" matInput rows="3" maxlength="500"></textarea>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.commentsOrSrp').hasError('pattern') ||
                                RTAForm.get('rtaRequestDetails.commentsOrSrp').hasError('hasBackSlash')">
                                    The characters \ / * ? " < > | are not allowed.
                                </mat-error>
                                <mat-error *ngIf="RTAForm.get('rtaRequestDetails.commentsOrSrp').hasError('required')">
                                    This is required Field
                                </mat-error>
                            </mat-form-field>
        
                        </div>
                    </div>
                    <div #scrollToProposed class="mt-3 cws-header">Proposed Duration (choose one or both) </div>
                    <div  class="row mx-2 mt-3 sg-current border rounded w-30" 
                    *ngIf="isProposedDurationValid">
                        <div class="col-12">
                            <div class="row p-2 "><span 
                                    class="material-icons-outlined pr-2 sg-supplier-management-info pt-1 sg-info">info</span>
                                    <span class="pt-1"> At least one Proposed Duration must be Selected</span>
                            </div>
                        </div>
                    </div>
                    <div class="row px-3 pt-2">
                        <div class="col-3 pl-0 sg-col-sm-3">
                            <label class="sg-form-field-label pl-0">
                                Quantity of Nonconforming Parts
                            </label>
                            <mat-form-field class="w-100 sg-validation" appearance="outline">
                                <input matInput formControlName="quantityOfNonconformingParts" (keydown)="onKeyDown($event)"/>
                                <!-- <mat-error *ngIf="RTAForm.get('rtaRequestDetails.quantityOfNonconformingParts').hasError('pattern')">
                                    Integers are allowed only.
                                </mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-5 pl-0 sg-col-md-5">
                            <label class="sg-form-field-label pl-0">
                                Date
                            </label>
                            <div class="row pl-3 pr-0">
                                <div class="col-6 px-0">
                                    <span class="mr-2">From</span>
                                    <mat-form-field appearance="outline" class="w-75">
                                        <input matInput  [matDatepicker]="from" formControlName="fromDate">
                                        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
                                        <mat-datepicker #from></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-6 pr-0 pl-2">
                                    <span class="mr-2">To</span>
                                    <mat-form-field appearance="outline" class="w-75">
                                        <input matInput  [matDatepicker]="to" formControlName="toDate">
                                        <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
                                        <mat-datepicker #to></mat-datepicker>
                                        <mat-error *ngIf="RTAForm.get('rtaRequestDetails.toDate').hasError('dateRangeError')">
                                            From date should not exceed To date.
                                        </mat-error>
                                    </mat-form-field>   
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </ng-container>
                <div  class="mat-dialog-title mb-0 border-bottom  cws-header">Section 1B - Current Condition </div>
                <div  class="row mx-2 mt-3 sg-current border rounded w-30" *ngIf="currentCondition.controls.length == 0">
                    <div class="col-12">
                        <div class="row p-2"><span 
                                class="material-icons-outlined pr-2 sg-supplier-management-info pt-1 sg-info">info</span>
                                <span class="pt-1"> At least one Current Condition must be added</span></div>
                    </div>
                </div>
                <ng-container  formArrayName="currentCondition">    
                <div  class="row px-3 my-3 rta-current-condition"
                    *ngFor="let currentControls of currentCondition.controls; let i = index" [formGroupName]="i" [attr.id]="'scrollSection-' + i">
                    <!-- <ng-container [formGroupName]="i"> -->
                        
                        <div class="px-1 pt-2">
                            <div class="letter-container">{{i+1}}</div>
                        </div>
                        <div class="col-9 pt-2 pr-0">
                            <div class="row px-3 mx-0">
                                <div class="col-6 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Drawing/Spec.Requirement <span
                                            class="sg-form-field-required-marker ml-1">*</span>
                                    </label>
                                    <mat-form-field class="w-100 sg-validation" appearance="outline">
                                        <input matInput formControlName="drawingOrSpecRequirement" />
                                        <mat-error *ngIf="RTAForm.get('currentCondition.' + i + '.drawingOrSpecRequirement').hasError('required')">
                                            This is required Field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-6 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Blue Print Zone/Spec. Section <span
                                            class="sg-form-field-required-marker ml-1">*</span>
                                    </label>
                                    <mat-form-field class="w-100 sg-validation" appearance="outline">
                                        <input matInput formControlName="bluePrintZoneSection" />
                                        <mat-error *ngIf="RTAForm.get('currentCondition.' + i + '.bluePrintZoneSection').hasError('required')">
                                            This is required Field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row px-3 mx-0">
                                <div class="col-4 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Actual Condition <span
                                            class="sg-form-field-required-marker ml-1">*</span>
                                    </label>
                                    <mat-form-field class="w-100 sg-validation" appearance="outline">
                                        <input matInput formControlName="actualCondition" />
                                        <mat-error *ngIf="RTAForm.get('currentCondition.' + i + '.actualCondition').hasError('required') ||
                                        RTAForm.get('currentCondition.' + i + '.actualCondition').invalid">
                                            This is required Field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-4 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Quantity
                                        <span class="sg-form-field-required-marker ml-1" *ngIf="isQauntityRequire">*</span>
                                    </label>
                                    <mat-form-field class="w-100 sg-validation" appearance="outline">
                                        <input matInput formControlName="quantity" (keydown)="onKeyDown($event)" />
                                        <mat-error *ngIf="RTAForm.get('currentCondition.' + i + '.quantity').hasError('required') ||
                                        RTAForm.get('currentCondition.' + i + '.quantity').invalid">
                                            This is required Field
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-4 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Serial Number
                                    </label>
                                    <mat-form-field class="w-100 sg-validation   cws-error-container" appearance="outline">
                                        <input matInput formControlName="serialNumber" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row px-3 mx-0 py-2">
                                <div class="col-12 pl-0">
                                    <label class="sg-form-field-label  d-block font-weight-normal w-100">
                                        Additional Comments
                                    </label>
                                    <mat-form-field class="w-100 sg-validation   cws-error-container" appearance="outline">
                                        <textarea formControlName="additionalComments" matInput rows="3" maxlength="500"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-2 pt-2 pr-1 border-left">
                            <div class="row pl-2 mx-0 pb-4">
                                <div class="col-12 px-0">Disposition (Solar) </div>
                                <div class="mt-2 col-12 px-0">
                                    <mat-form-field class="w-100 sg-validation" appearance="none">
                                        <input matInput formControlName="disposition" readonly/>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row pl-2 mx-0 pt-3">
                                <label class="sg-form-field-label col-12 px-0   d-block font-weight-normal w-100">
                                    Disposition Notes (Solar)
                                </label>
                                <div class="mt-2 col-12 px-0">
                                    <mat-form-field class="w-100 sg-validation" appearance="none">
                                        <input matInput formControlName="dispositionNotes" readonly/>
                                    </mat-form-field>
                                </div>
                            </div>
                            
                        </div>
                        <div class="px-3 pt-2">
                            <mat-icon class="clear-icon cursor" *ngIf="!isRTAReadOnly && !isRowDispositioned(i)"
                            (click)="onDeleteIconClick(i)">delete</mat-icon>
                            <mat-icon class="disabled-icon" *ngIf="isRTAReadOnly || isRowDispositioned(i)"
                            [matTooltip]="isRowDispositioned(i) ? 'This line item has been dispositioned by Solar and cannot be removed.' : ''">delete</mat-icon>
                        </div>
                    <!-- </ng-container> -->
                </div>
                </ng-container>
                    <div class="row px-3 pt-2 pb-3">
                        <button mat-stroked-button class="mat-primary mat-stroked-button mr-3"
                                [ngClass]="isRTAReadOnly ? '' : 'sg-primary-stroked'"
                                type="button"
                                [disabled]="isRTAReadOnly || currentCondition.controls.length >= effectiveSection1BMaxRows"
                                (click)="onAddConditionClick()">Add Condition</button>
                        <span class="pt-2 pl-2 sg-info" *ngIf="section1BOverflow && currentCondition.controls.length < effectiveSection1BMaxRows">
                            You have more than {{section1BInlineCap}} line items. On submit, all line items will be sent to Windchill as an attached Word (.docx) document.
                        </span>
                        <span class="pt-2 pl-2 sg-info" *ngIf="currentCondition.controls.length >= effectiveSection1BMaxRows">
                            If you have more than {{effectiveSection1BMaxRows}} current conditions, please reach out to your STE.
                        </span>
                    </div>
                    <div class="mat-dialog-title mb-0 cws-header">Attachments</div>
                    <div class="col-12 pl-0 pb-3" class="fileAttachmentContainer">
                        <div class="pb-2" *ngFor="let item of  linkList; let ind = index">
                            <span class="">
                                 <span>{{item.linkTitle}}</span>
                            </span>
                             <span class="material-icons-outlined pointer-cursor mat-primary pl-2"
                             [ngClass] = "!isRTAReadOnly ? 'pointer-cursor' : 'cursor-not-allowed'" 
                             (click)="!isRTAReadOnly ? removeLinkList(ind) : '' ">close</span> 
                         </div>
                    </div>
                    <div class="col-12 pl-0 pb-3 ppap-link" *ngIf="!isRTAReadOnly">
                        <input type="file" formControlName="filesUploadAttachment" id="filesUpload" (change)="onFileSelected($event)" style="display:none"/> 
                        <a (click)="fileUpload()" class="enable-icon underline sg-link-primary">Add Attachment</a>
                    </div>
                    <div class="col-12 pl-0 pb-3 ppap-link" *ngIf="isRTAReadOnly">
                        <input type="file" formControlName="filesUploadAttachment" id="filesUpload" (change)="onFileSelected($event)" style="display:none"/> 
                        <a (click)="fileUpload()" class="enable-icon underline disable-link cursor-not-allowed">Add Attachment</a>
                    </div>
                </div>
                <div class="row mx-0 pt-3" *ngIf="isRTAEditForm && showDispositionSection">
                    <div class="mat-dialog-title w-100 mb-0 border-bottom  cws-header">Section 2 - RTA Disposition </div>
                    <div class="row w-100 pl-3 pr-3">
                        <div class="col-12 px-0 pt-3 sg-form-field-label">Solar Approval Effectivity</div>
                    </div>
                    <div class="row w-100 pl-3 pr-3">
                        <div class="col-4 px-0">
                            <div class="row">
                                <div class="sg-form-field-label col-6 px-2 pt-3 pb-1">
                                    Total Quantity of Parts
                                </div>
                                <div class="sg-form-field-label col-6 px-2 pt-3 pb-1">
                                    Solar Approved Period
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 px-2" style="word-wrap: break-word;">
                                    {{ rtaDisposition?.totalQuantityOfParts || '-' }}
                                </div>
                                <div class="col-6 px-2" style="word-wrap: break-word;">
                                    {{ rtaDisposition?.solarApprovedPeriod || '-' }}
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Deviation Permit or Concession
                            </div>
                            <div>
                                {{ rtaDisposition?.deviationPermit || '-' }}
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Advanced Reject Notice (ARN)
                            </div>
                            <div>
                                {{ rtaDisposition?.advancedRejectNotice || '-' }}
                            </div>
                        </div>
                    </div>
                    <div class="row w-100 pl-3 pr-3">
                        <div class="col-4 px-0">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Associated PPAP
                            </div>
                            <div>
                                {{ rtaDisposition?.associatedPPAP || '-' }}
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Associated OHRS
                            </div>
                            <div>
                                {{ rtaDisposition?.associatedOHRS || '-' }}
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Applicable Engineering Specs (ES)
                            </div>
                            <div>
                                {{ rtaDisposition?.applicableEngineeringSpecs || '-' }}
                            </div>
                        </div>
                    </div>
                    <div class="row w-100 pl-3 pr-3 pb-5">
                        <div class="col-6 px-0">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Part Identification Location & Method (per drawing unless instructed otherwise):
                            </div>
                            <div>
                                {{ rtaDisposition?.partIdentificationLocationMethod || '-' }}
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="sg-form-field-label pt-3 pb-1">
                                Additional Solar Comments / Instructions / Conditions:
                            </div>
                            <div>
                                {{ rtaDisposition?.additionalSolarComments || '-' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </mat-drawer-container>
        </div>
        <div class="sg-footer-section w-100">
        <div class="col-12 px-5 pt-2 pb-5">
            <div class="mat-dialog-actions row mx-0 justify-content-end">
                <button mat-raised-button class="mat-primary rep-action-button rep-btn-margin mr-4"
                    type="button" [disabled]="isRTAEditForm ? !RTAForm.valid || !RTAForm.dirty : !RTAForm.valid"
                    (click)="onRtaFormSubmit()">Submit</button>
                <!-- TEMP (manual verification): generates the Section 1B overflow .docx and shows a download link. Non-production only. Remove later. -->
                <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button mr-3"
                    type="button" *ngIf="section1BOverflow && section1BFeatureEnabled && showOverflowDocTest"
                    matTooltip="TEMP: builds the Word (.docx) that would be uploaded to Windchill for the >12 line items so you can inspect it"
                    (click)="onTestGenerateDocClick()">Test Overflow Doc</button>
                <a *ngIf="testDocUrl && section1BFeatureEnabled && showOverflowDocTest" class="mr-3 align-self-center" [href]="testDocUrl" [download]="testDocFileName">
                    Download generated doc ({{testDocFileName}})
                </a>
                <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button mr-3" *ngIf="canAuthorRta && (!isRTAEditForm || isDraftRtaStatus)"
                  type="button" matTooltip="Saves your progress. The RTA will not be sent to Solar for review until you click Submit"
                    (click)="onRtaSaveDraftClick()">
                    Save</button>  
                    <!-- !RTAForm.get('rtaRequestDetails').valid -->
                    <!-- ||
                    ((!RTAForm.get('rtaRequestDetails.fromDate').value) || (!RTAForm.get('rtaRequestDetails.toDate').value)) &&
                    !RTAForm.get('rtaRequestDetails.quantityOfNonconformingParts').value -->
                <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button mr-3"
                    type="button" (click)="onClickBackOrClose()">Close</button>
            </div>
        </div>
        </div>
    </form>
</div>

<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <div class="d-flex flex-column align-items-center">
        <mat-spinner></mat-spinner>
        <div *ngIf="loadingMessage" class="mt-3 text-white">{{ loadingMessage }}</div>
    </div>
</div>
